import {
  Backdrop,
  Box,
  Button,
  Fade,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import useCustomState from "../../hooks/State";
import Call from "../../service/API";
import Swal from "sweetalert2";
import { ERROR_COLOR, GREEN_PRIMRY, WHITE } from "../../utils/const";
import { Height } from "@material-ui/icons";

const DeviceEditModal = ({ open, info, type }) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
  };
  const deviceName = useCustomState(info.value.water_meter_name);
  const tank_height = useCustomState(
    info.value.other_information?.tank_height
      ? info.value.other_information.tank_height
      : 0
  );
  const up_sensor = useCustomState(
    info.value.other_information?.up_sensor
      ? info.value.other_information.up_sensor
      : 0
  );
  const down_sensor = useCustomState(
    info.value.other_information?.down_sensor
      ? info.value.other_information.down_sensor
      : 0
  );
  const position = useCustomState(
    info.value.other_information?.position
      ? info.value.other_information.position
      : 0
  );
  const handleClose = () => {
    open.handleChange(false);
  };
  const renderTypeContext = () => {
    switch (type) {
      case 1:
        return (
          <>
            <Grid container xs={12} sm={12} md={12} lg={12}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{ margin: "5px 0" }}
              >
                <TextField
                  aria-readonly={true}
                  value={deviceName.value}
                  fullWidth
                  variant="standard"
                  label="نام دستگاه"
                  InputLabelProps={{
                    style: {
                      fontFamily: "Vazir",
                    },
                  }}
                  onChange={(e) => deviceName.handleChange(e.target.value)}
                  size="small"
                ></TextField>
              </Grid>
            </Grid>
          </>
        );
      case 2:
        return (
          <>
            <Grid container xs={12} sm={12} md={12} lg={12}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{ margin: "5px 0" }}
              >
                <TextField
                  aria-readonly={true}
                  value={tank_height.value}
                  fullWidth
                  variant="standard"
                  label="ارتفاع مخزن (mm)"
                  InputLabelProps={{
                    style: {
                      fontFamily: "Vazir",
                    },
                  }}
                  onChange={(e) =>
                    tank_height.handleChange(Number(e.target.value))
                  }
                  size="small"
                ></TextField>
                <TextField
                  aria-readonly={true}
                  value={position.value}
                  fullWidth
                  variant="standard"
                  label="ارتفاع نصب (mm)"
                  InputLabelProps={{
                    style: {
                      fontFamily: "Vazir",
                    },
                  }}
                  onChange={(e) =>
                    position.handleChange(Number(e.target.value))
                  }
                  size="small"
                ></TextField>
                <TextField
                  aria-readonly={true}
                  value={up_sensor.value}
                  fullWidth
                  variant="standard"
                  label="ارتفاع سنسور بالا (mm)"
                  InputLabelProps={{
                    style: {
                      fontFamily: "Vazir",
                    },
                  }}
                  onChange={(e) =>
                    up_sensor.handleChange(Number(e.target.value))
                  }
                  size="small"
                ></TextField>
                <TextField
                  aria-readonly={true}
                  value={down_sensor.value}
                  fullWidth
                  variant="standard"
                  label="ارتفاع سنسور پایین"
                  InputLabelProps={{
                    style: {
                      fontFamily: "Vazir",
                    },
                  }}
                  onChange={(e) =>
                    down_sensor.handleChange(Number(e.target.value))
                  }
                  size="small"
                ></TextField>
              </Grid>
            </Grid>
          </>
        );
      default:
        return (
          <>
            <Grid container xs={12} sm={12} md={12} lg={12}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{ margin: "5px 0" }}
              >
                <TextField
                  aria-readonly={true}
                  value={deviceName.value}
                  fullWidth
                  variant="standard"
                  label="نام دستگاه"
                  InputLabelProps={{
                    style: {
                      fontFamily: "Vazir",
                    },
                  }}
                  onChange={(e) => deviceName.handleChange(e.target.value)}
                  size="small"
                ></TextField>
              </Grid>
            </Grid>
          </>
        );
    }
  };
  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open.value}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open.value}>
          <Box sx={style} style={{ borderRadius: "8px" }}>
            <Typography id="transition-modal-title" variant="h6" component="h2">
              مشخصات دستگاه{" "}
            </Typography>
            {renderTypeContext()}
            <Grid container xs={12} sm={12} md={12} lg={12}>
              <Grid
                style={{ marginTop: "48px" }}
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
              >
                <Button
                  onClick={() => {
                    editDevice(
                      info,
                      deviceName,
                      tank_height,
                      up_sensor,
                      down_sensor,
                      position,
                      handleClose
                    );
                  }}
                  style={{ color: "#fff" }}
                  variant="contained"
                  color="primary"
                >
                  اعمال تغییرات
                </Button>
                <Button
                  onClick={handleClose}
                  style={{
                    color: "#fff",
                    marginRight: "4px",
                    backgroundColor: ERROR_COLOR,
                  }}
                  variant="contained"
                >
                  بستن
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Fade>
      </Modal>
    </>
  );
};
export default DeviceEditModal;
const editDevice = (
  infoState,
  nameState,
  tank_height,
  up_sensor,
  down_sensor,
  position,
  closeModal
) => {
  const data = {
    water_meter_serial: infoState.value.water_meter_serial,
    water_meter_name: nameState.value,
    water_meter_location: infoState.value.water_meter_location,
    other_information: {
      tank_height: tank_height.value,
      up_sensor: up_sensor.value,
      down_sensor: down_sensor.value,
      position: position.value,
    },
    water_meter_validation: infoState.value.water_meter_validation,
    water_meter_activation: infoState.value.water_meter_activation,
    water_meter_condition: infoState.value.water_meter_condition,
    water_meter_module_id:
      infoState.value.water_meter_module_info.water_meter_module_id,
    water_meter_project_id: infoState.value.water_meter_project_info.project_id,
    water_meter_user_id: infoState.value.water_meter_user_info.user_id,
    call_publisher: null,
    water_meter_manual_number: null,
  };
  Call("POST", "watermeters/admin/edit", data)
    .then((response) => {
      if (response.data.code === 200) {
        let new_info = { ...infoState.value };
        new_info.water_meter_name = nameState.value;
        new_info.other_information = data.other_information;
        infoState.handleChange(new_info);
        closeModal();
        Swal.fire({
          toast: true,
          title: "تغییرات با موفقیت اعمال شد",
          color: WHITE,
          timer: 4000,
          position: "bottom-start",
          icon: "success",
          showConfirmButton: false,
          timerProgressBar: true,
          background: GREEN_PRIMRY,
        });
      }
    })
    .catch((error) => {
      if (error.response) {
        Swal.fire({
          toast: true,
          title: "در اعمال تغییرات مشکلی رخ داده",
          color: WHITE,
          timer: 4000,
          position: "bottom-start",
          icon: "error",
          showConfirmButton: false,
          timerProgressBar: true,
          background: ERROR_COLOR,
        });
      }
    });
};
